var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VSlideYReverseTransition", [
    _vm.show && _vm.loading
      ? _c(
          "div",
          { staticClass: "support-popup-component pa-3" },
          [
            _c("div", { staticClass: "mb-3" }, [
              _vm._v("\n      Zendesk is loading...\n    ")
            ]),
            _vm._v(" "),
            _c("VProgressCircular", {
              attrs: { size: 24, color: "primary", indeterminate: "" }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }